export default "__VITE_ASSET__CzBq4yqU__"